import React from 'react'
import axios from 'axios';

const instance = axios.create();

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
};

export const V2BaseURL = process.env.REACT_APP_V2_SERVER_URL
export const V1BaseURL = process.env.REACT_APP_SERVER_URL
console.log({ V2BaseURL, V1BaseURL })

export const V2Axios = axios.create({
  baseURL: V2BaseURL,
  withCredentials: true,
  headers,
});

export const V1Axios = axios.create({
  baseURL: V1BaseURL,
  withCredentials: true,
  headers,
});

export default instance;
